import React from 'react';
import { motion } from 'framer-motion';
import styles from './SectionWhy.module.scss';

const statements = [
  { id: '01', title: 'BUILD WITH PURPOSE' },
  { id: '02', title: 'DESIGN WITH INTENT' },
  { id: '03', title: 'THINK BEYOND LAUNCH' },
  { id: '04', title: 'GROW TOGETHER' }
];

const SectionWhy: React.FC = () => {
  return (
    <section className={`${styles.whySection} dark-section`} id="home-why">
      <div className="torn-edge-top" />
      <div className="container">
        <div className={styles.grid}>
          {statements.map((item, index) => (
            <motion.div
              key={item.id}
              className={styles.statementBlock}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <span className={styles.number}>{item.id}</span>
              <h3 className={styles.title}>{item.title}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectionWhy;
